import { useSession } from 'next-auth/react';
import { useEffect, useState } from 'react';
import useSWRImmutable from 'swr/immutable';

import { NEXT_AUTH_STATUSES } from '@/lib/constants';
import { ShipmentTableSettings } from '@/types';
import { SavedItemsSingleApiResponse } from '@/types/api-types';
import { request } from '@/utils/api/request';
import { getShipmentTableSettingsUrl } from '@/utils/helpers/api-urls';
import { logEvent } from '@/utils/logger';

export const useShipmentTableSettings = () => {
  const { status } = useSession();
  const isAuthenticated = status === NEXT_AUTH_STATUSES.AUTHENTICATED;
  const [tableSettings, setTableSettings] = useState<ShipmentTableSettings>();
  const { data, isLoading } = useSWRImmutable<SavedItemsSingleApiResponse>(
    isAuthenticated ? getShipmentTableSettingsUrl() : null,
    request,
  );

  useEffect(() => {
    try {
      const tableSettingsValue = data?.savedItem
        ? (JSON.parse(data.savedItem.data) as ShipmentTableSettings)
        : undefined;

      setTableSettings(tableSettingsValue);
    } catch (e: any) {
      logEvent.error('Error parsing shipment table settings', e);
    }
  }, [data]);

  const handleUpdate = async (updatedTableSettings: ShipmentTableSettings) => {
    if (isLoading || !isAuthenticated) return null;

    return request<SavedItemsSingleApiResponse>(
      getShipmentTableSettingsUrl(),
      { body: { data: JSON.stringify(updatedTableSettings) } },
      'POST',
    );
  };

  return { tableSettings, isLoading, update: handleUpdate };
};
